import React from 'react'
import {FaGithub, FaLinkedin} from 'react-icons/fa'
import {HiOutlineMail} from "react-icons/hi";
import {BsFillPersonLinesFill} from "react-icons/bs";

const SocialLinks = () => {
    
    const links = [
        {
            id: 1,
            child: (
                <>
                LinkedIn 
                    <FaLinkedin size={30} />
                </>
            ),
            href: 'https://www.linkedin.com/in/matthew-puyat-112318195/',
            style: 'rounded-tr-md'
        },
        {
            id: 2,
            child: (
                <>
                Github 
                    <FaGithub size={30} />
                </>
            ),
            href: 'https://github.com/Matirix',
            style: ''
        },
        {
            id: 3,
            child: (
                <>
                Mail 
                    <HiOutlineMail size={30} />
                </>
            ),
            href: 'mailto:Matirix@live.com',
            style: 'rounded-br-md'   
        }
        // {
        //     id: 4,
        //     child: (
        //         <>
        //         Resume 
        //             <BsFillPersonLinesFill size={30} />
        //         </>
        //     ),
        //     href: '',
        //     style: 'rounded-br-md',
        //     download: true,
        // },
        
    ]

  return (
    <div className='hidden md:visible md:flex flex-col top-[35%] left-0 fixed'>
        <ul>
            {links.map (({id, child, href, style, download}) => (

            <li key={id} className={`flex justify-between items-center w-40 h-14 px-4  ml-[-100px] bg-gray-500 backdrop-blur-md bg-white/25 hover:rounded-md duration-300 hover:ml-[-10px] ${style}`} >
            
            <a className='flex justify-between items-center w-full text-white' 
            href={href}
            download={download}
            target='_blank'
            rel='noreferrer'>
                {child}
            </a>
            </li>

            ))}
        </ul>
    </div>
  )
}

export default SocialLinks